__turbopack_context__.v({
  "cta-text": "_6WWsiq_cta-text",
  "error-banner": "_6WWsiq_error-banner",
  "left": "_6WWsiq_left",
  "placeholder": "_6WWsiq_placeholder",
  "reverse": "_6WWsiq_reverse",
  "right": "_6WWsiq_right",
  "slider-track": "_6WWsiq_slider-track",
  "slider-track-actions": "_6WWsiq_slider-track-actions",
  "transition": "_6WWsiq_transition",
});
